<template>
  <div data-cy="historico-card-container">
    <div
      v-if="loading"
      style="position: absolute; background-color: rgba(255,255,255,0.5); width: 100%; height: 100%; z-index: 1"
      data-cy="historico-card-loading"
    ></div>
    <div
      class="d-flex flex-column flex-md-row"
      data-cy="historico-card-content"
    >
      <div
        style="width: 200px"
        :class="
          `d-flex flex-column justify-content-center rounded py-5 px-2 ${
            hasAction(history.statusMarcacao) ? 'bg-primary' : 'bg-light'
          }`
        "
        data-cy="historico-card-status-section"
      >
        <h5
          :class="
            `text-white text-center ${
              hasAction(history.statusMarcacao) ? '' : 'text-muted'
            }`
          "
          data-cy="historico-card-status-title"
        >
          <font-awesome-icon
            icon="info-circle"
            data-cy="icon-historico-status"
          ></font-awesome-icon>
          {{ history.statusMarcacao.replace(/_/g, " ") }}
        </h5>
        <div
          :class="
            `d-flex flex-row justify-content-center ${
              hasAction(history.statusMarcacao) ? '' : 'invisible'
            }`
          "
          data-cy="historico-card-actions"
        >
          <b-button
            class="m-1 rounded-0 btn-outline-light"
            variant="white"
            @click="reschedule"
            data-cy="btn-historico-reagendar"
          >
            Reagendar
          </b-button>
          <b-button
            class="m-1 rounded-0 btn-outline-light"
            variant="white"
            v-b-modal="`agendamento-${history.id}`"
            data-cy="btn-historico-cancelar"
          >
            <font-awesome-icon
              icon="trash"
              data-cy="icon-historico-cancelar"
            ></font-awesome-icon>
          </b-button>
        </div>
      </div>
      <div class="card flex-row ml-md-3" data-cy="historico-card-info">
        <div
          class="bg-light border-right h-100 info-wrapper"
          v-if="!mobile"
          data-cy="historico-card-info-label"
        >
          <span class="info-label" data-cy="historico-info-label-text">
            INFORMAÇÕES
          </span>
        </div>
        <div
          class="card-body d-flex flex-md-row flex-column"
          data-cy="historico-card-body"
        >
          <div
            :class="`pr-3 ${mobile ? '' : 'border-right'}`"
            data-cy="historico-card-data-section"
          >
            <p class="history" data-cy="historico-data">
              <strong class="text-primary" data-cy="historico-data-label">
                Data
              </strong>
              <span data-cy="historico-data-value">
                {{ history.horaAgendamento | moment("LLL") }}
              </span>
            </p>
          </div>
          <div
            :class="`px-3 ${mobile ? '' : 'border-right'} d-flex flex-column`"
            data-cy="historico-card-consulta-section"
          >
            <p class="history" data-cy="historico-especialidade">
              <strong class="text-primary">Consulta:</strong>
              {{ history.especialidade }}
            </p>
            <p class="history" data-cy="historico-paciente">
              <strong class="text-primary">Paciente:</strong>
              {{ history.paciente }}
            </p>
            <p class="history" data-cy="historico-profissional">
              <strong class="text-primary">Médico:</strong>
              {{ history.profissional }}
            </p>
            <p class="history" data-cy="historico-convenio">
              <strong class="text-primary">Convênio:</strong>
              {{ history.convenio }}
            </p>
          </div>
          <div
            class="pl-3 d-flex flex-column"
            data-cy="historico-card-clinica-section"
          >
            <p class="history" data-cy="historico-clinica">
              <strong class="text-primary">Clinica:</strong>
              {{ history.clinica || "" }}
            </p>
            <p
              class="history"
              v-html="
                `<strong class='text-primary'>Telefones:</strong>${phones}`
              "
              data-cy="historico-telefones"
            ></p>
            <p class="history" data-cy="historico-endereco">
              <strong class="text-primary">Endereço:</strong>
              {{ address }}
            </p>
            <p
              class="history"
              v-if="history.urlPagamento"
              data-cy="historico-pagamento-url"
            >
              <strong class="text-primary">Plat. Pagamento:</strong>
              <b-button
                @click="urlPagamento(history.urlPagamento)"
                size="sm"
                data-cy="btn-historico-abrir-pagamento"
              >
                Abrir
                <font-awesome-icon
                  :icon="['fas', 'money-check-alt']"
                  data-cy="icon-historico-pagamento"
                ></font-awesome-icon>
              </b-button>
            </p>
            <p
              class="history"
              v-else-if="history.statusMarcacao == 'PAGAMENTO_AGUARDANDO'"
              data-cy="historico-pagamento-envio"
            >
              <strong class="text-primary">Envio comp. Pagamento:</strong>
              <b-button
                @click="routePagamento(history.id)"
                size="sm"
                data-cy="btn-historico-enviar-pagamento"
              >
                Enviar
                <font-awesome-icon
                  :icon="['fas', 'money-check-alt']"
                  data-cy="icon-historico-enviar-pagamento"
                ></font-awesome-icon>
              </b-button>
            </p>
          </div>
        </div>
      </div>

      <b-modal
        style="z-index: 9999"
        @ok="cancel"
        class="text-black"
        :id="`agendamento-${history.id}`"
        centered
        data-cy="modal-historico-cancelar"
      >
        <h6 data-cy="modal-historico-cancelar-titulo">
          Por favor, nos informe o motivo do cancelamento
        </h6>
        <b-form-textarea
          id="textarea"
          v-model="motivo"
          placeholder="diga-nos o motivo"
          rows="4"
          max-rows="6"
          required
          :state="motivo || motivo !== ''"
          data-cy="campo-historico-motivo-cancelamento"
        ></b-form-textarea>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { hasAction } from "@/core/enumHelper";
import { axiosInstance as Axios } from "@/main";

export default {
  name: "historico-card",
  props: ["history"],
  data() {
    return {
      motivo: "",
      loading: false
    };
  },
  methods: {
    reschedule() {
      this.$store.dispatch("set_reschedule", this.history);

      this.$router.push({
        name: "reschedule",
        params: { organizationId: this.$route.params.organizationId }
      });
    },
    routePagamento(id) {
      this.$store.commit("set_agendamento", { id });
      this.$router.push({
        name: "pagamento",
        params: {
          organizationId: this.$route.params.organizationId
        },
        query: {
          marcacaoId: id
        }
      });
    },
    hasAction: hasAction,
    async cancel(bvModalEvt) {
      if (this.motivo === "") {
        bvModalEvt.preventDefault();
        return;
      }

      this.loading = true;
      try {
        await Axios.patch(
          `${this.$serverHost}protected/me/agendamentos/${this.history.id}/cancelar`,
          null,
          {
            params: {
              motivo: this.motivo
            },
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`
            }
          }
        );

        this.$bvToast.toast(`Agendamento cancelado com sucesso.`, {
          title: "Sucesso",
          variant: "success",
          autoHideDelay: 5000,
          appendToast: true
        });

        let payload = {
          url: this.$serverHost
        };

        this.$store.dispatch("load_history", payload);
        this.loading = false;
      } finally {
        this.loading = false;
      }
    },
    urlPagamento(url) {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        window.location.href = url;
      } else {
        const win = window.open(url, "_blank");
        win.focus();
      }
    }
  },
  computed: {
    mobile() {
      return this.$store.getters.width < 768;
    },
    phones() {
      return this.history.telefones && this.history.telefones.length > 0
        ? this.history.telefones.join("<br/>")
        : "-";
    },
    address() {
      return this.history.endereco;
    }
  }
};
</script>

<style>
.history {
  display: inline-flex;
  flex-direction: column;
}

.info-wrapper {
  min-width: 45px;
  width: 45px;
}

.info-label {
  -webkit-transform: rotate(-90deg);
  -moz-transform: rotate(-90deg);
  -ms-transform: rotate(-90deg);
  -o-transform: rotate(-90deg);
  transform: rotate(-90deg);

  position: absolute;
  top: 55%;
  width: 40px;
  white-space: nowrap;
  font-weight: bold;
  color: hsla(210, 14%, 70%, 1);
}
</style>
